import React, { PropsWithChildren, useCallback } from 'react'
import { TOneXTwoBet } from './types'
import LegacyBetContext from "@root/bet_utils/context/bet"
import useEnrichBet, { EnrichedBet } from '@root/bet_utils/useEnrichBet'

export type IOneXTwoContext = EnrichedBet<TOneXTwoBet>

export const OneXTwoContext = React.createContext<IOneXTwoContext>({bet: {} as any, changePicks: () => {}, displaySaveResult: undefined})

const WithOneXTwoBet: React.FC<PropsWithChildren<{initialBet: TOneXTwoBet, authToken: string}>> = ({initialBet, authToken, children}) => {
  const enrichedBet = useEnrichBet<TOneXTwoBet>(initialBet, authToken, useCallback((prev: TOneXTwoBet, fromScoringUpdate: TOneXTwoBet) => {
    return {
      ...prev,
      actual_result: fromScoringUpdate.actual_result
    }
  }, []));

  return <LegacyBetContext.Provider value={enrichedBet.bet}>
    <OneXTwoContext.Provider value={enrichedBet}>
      {children}
    </OneXTwoContext.Provider>
  </LegacyBetContext.Provider>
}

export default WithOneXTwoBet
